module.exports = __webpack_public_path__ + "images/entity-view-skus-5a127ee1.svg";